export class GetCertificates {
  static readonly type = "[Certificates] Get certificates";
}
